var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShowBtn)?_c('FitButton',{staticClass:"coupon-item-btn",class:_vm.stampClass,attrs:{"disabled":_vm.isBtnDisable},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.btnText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }